/**
 * Font Finder — inspect the fonts used on a page
 *
 * Declares two web-accessible resources, `data/window/index.html` and
 * `data/inject/AND-Regular.otf`, matched to every http(s) origin with no
 * `use_dynamic_url` — so both are served at a fixed URL to any page. Neither is an
 * image, so both are probed with `probeFetch`; the `data/inject/` and `data/window/`
 * paths are distinctive to Font Finder.
 *
 * Manifest verified against version 0.6.5.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bhiichidigehdgphoambhjbekalahgha';

export const fontFinder: ExtensionDefinition = {
  id: ID,
  name: 'Font Finder',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'Two static WAR on every http(s) origin with no dynamic URL. Neither is an image, ' +
    'so both are fetched; the data/window and data/inject paths make detection conclusive.',
  signals: [
    {
      id: 'war-window-index-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch data/window/index.html — the panel UI document exposed to every origin at ' +
        'a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'data/window/index.html'),
    },
    {
      id: 'war-inject-font-otf',
      kind: 'web-accessible-resource',
      description:
        'Fetch data/inject/AND-Regular.otf — the injected sample font, an independent ' +
        'corroborating path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'data/inject/AND-Regular.otf'),
    },
  ],
};
